import { useEffect } from "react";

function App() {
  useEffect(() => {
    const redirectUrl = `https://shaadbin.ir${window.location.pathname}${window.location.search}`;
    window.location.replace(redirectUrl);
  }, []);

  return (
    <></>
  );
}

export default App;
